import { render, staticRenderFns } from "./WeeklyBanking.vue?vue&type=template&id=39d436ff&scoped=true&"
import script from "./WeeklyBanking.vue?vue&type=script&lang=js&"
export * from "./WeeklyBanking.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyBanking.vue?vue&type=style&index=0&id=39d436ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d436ff",
  null
  
)

export default component.exports